import { createRequestActionCreators, RequestAction, createPayloadAction } from 'helpers/actionsHelpers'
import {
  PublicTrendState,
  PublicBreakdownByMerchantState,
  PublicBreakdownByStateState,
  PublicBreakdownByCategoryState,
  PublicFilter,
} from 'interfaces/publicDashboard'
import { PayloadAction } from 'interfaces/action'


type GetPublicTrendRequest = PublicFilter
type GetPublicTrendResponse =
  & PublicTrendState

export const GET_PUBLIC_TREND = 'GET_PUBLIC_TREND' as const
export const getPublicTrendActionCreator = createRequestActionCreators<typeof GET_PUBLIC_TREND, GetPublicTrendRequest, GetPublicTrendResponse>(GET_PUBLIC_TREND)
type GetPublicTrend = RequestAction<typeof GET_PUBLIC_TREND, GetPublicTrendRequest, GetPublicTrendResponse>


type GetPublicBreakdownByStateRequest = Pick<PublicFilter, 'category' | 'incomeRange'>
type GetPublicBreakdownByStateResponse =
  & PublicBreakdownByStateState
export const GET_PUBLIC_BREAKDOWN_BY_STATE = 'GET_PUBLIC_BREAKDOWN_BY_STATE' as const
export const getPublicBreakdownByStateActionCreator = createRequestActionCreators<typeof GET_PUBLIC_BREAKDOWN_BY_STATE, GetPublicBreakdownByStateRequest, GetPublicBreakdownByStateResponse>(GET_PUBLIC_BREAKDOWN_BY_STATE)
type GetPublicBreakdownByState = RequestAction<typeof GET_PUBLIC_BREAKDOWN_BY_STATE, GetPublicBreakdownByStateRequest, GetPublicBreakdownByStateResponse>


type GetPublicBreakdownByCategoryRequest = Pick<PublicFilter, 'location' | 'incomeRange'>
type GetPublicBreakdownByCategoryResponse =
  & PublicBreakdownByCategoryState
export const GET_PUBLIC_BREAKDOWN_BY_CATEGORY = 'GET_PUBLIC_BREAKDOWN_BY_CATEGORY' as const
export const getPublicBreakdownByCategoryActionCreator = createRequestActionCreators<typeof GET_PUBLIC_BREAKDOWN_BY_CATEGORY, GetPublicBreakdownByCategoryRequest, GetPublicBreakdownByCategoryResponse>(GET_PUBLIC_BREAKDOWN_BY_CATEGORY)
type GetPublicBreakdownByCategory = RequestAction<typeof GET_PUBLIC_BREAKDOWN_BY_CATEGORY, GetPublicBreakdownByCategoryRequest, GetPublicBreakdownByCategoryResponse>


type GetPublicBreakdownByMerchantRequest = Pick<PublicFilter, 'category' | 'incomeRange' | 'location'>
type GetPublicBreakdownByMerchantResponse =
  & PublicBreakdownByMerchantState
export const GET_PUBLIC_BREAKDOWN_BY_MERCHANT = 'GET_PUBLIC_BREAKDOWN_BY_MERCHANT' as const
export const getPublicBreakdownByMerchantActionCreator = createRequestActionCreators<typeof GET_PUBLIC_BREAKDOWN_BY_MERCHANT, GetPublicBreakdownByMerchantRequest, GetPublicBreakdownByMerchantResponse>(GET_PUBLIC_BREAKDOWN_BY_MERCHANT)
type GetPublicBreakdownByMerchant = RequestAction<typeof GET_PUBLIC_BREAKDOWN_BY_MERCHANT, GetPublicBreakdownByMerchantRequest, GetPublicBreakdownByMerchantResponse>

export const SET_PUBLIC_FILTER = 'SET_PUBLIC_FILTER' as const
type SetPublicFilter = PayloadAction<typeof SET_PUBLIC_FILTER, Partial<PublicFilter>>
export const setPublicFilterActionCreator = (partialFilter: Partial<PublicFilter>): SetPublicFilter => createPayloadAction(SET_PUBLIC_FILTER, partialFilter)

export type PublicDashboardAction =
  | GetPublicTrend
  | GetPublicBreakdownByState
  | GetPublicBreakdownByCategory
  | GetPublicBreakdownByMerchant
  | SetPublicFilter
